import React, {useState} from 'react';
import {Button, DatePicker, message, Modal} from 'antd';
import dayjs from 'dayjs';
import {HttpService} from "../../services/http/Http.service";
import {SimulatorPersonIdPair} from "../../model/models";
import {HttpErrorService} from "../../services/http/HttpError.service";

interface PracticeNotifyProps {
    title?: string;
    selectedSimulatorPersonPairs: SimulatorPersonIdPair[];
    onSuccess: () => void;
    minProtocolDate?: Date | null;
}

const PracticeNotify: React.FC<PracticeNotifyProps> = ({ title, selectedSimulatorPersonPairs, onSuccess, minProtocolDate}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(null);

    const openModal = () => {
        if (selectedSimulatorPersonPairs.length > 0) {
            setIsModalOpen(true);
        } else {
            message.error("Nessun utente selezionato.");
        }
    };

    const handleConfirm = async () => {
        if (!selectedDate) {
            message.error("Seleziona una data prima di continuare.");
            return;
        }

        try {
            await HttpService.getInstanceAxios().post(
                `/file-ts/notified?communicationDate=${selectedDate.toISOString()}`,
                selectedSimulatorPersonPairs
            );

            message.success("Data comunicazione salvata con successo.");
            setIsModalOpen(false);
            onSuccess();
        } catch (error) {
            HttpErrorService.handle("Errore durante il salvataggio della data.", error, true);
        }
    };

    const disabledDate = (current: dayjs.Dayjs) => {
        if (!minProtocolDate){
            return false;
        }
        const minDate = dayjs(minProtocolDate);
        return current && current.isBefore(minDate, 'day');
    };

    return (
        <>
            <Button
                    onClick={openModal}
                    size={"large"}
                    disabled={selectedSimulatorPersonPairs.length === 0}
                    type={"default"}>
                {title ?? 'Notifica'}
            </Button>
            <Modal
                title="Seleziona data di notifica"
                open={isModalOpen}
                onOk={handleConfirm}
                onCancel={() => setIsModalOpen(false)}
                okText="Conferma"
                cancelText="Annulla"
            >
                <DatePicker
                    style={{ width: "100%" }}
                    value={selectedDate}
                    onChange={setSelectedDate}
                    format="DD/MM/YYYY"
                    disabledDate={disabledDate}
                />

            </Modal>
        </>
    );
};

export default PracticeNotify;
